import { Component } from '@angular/core';
import {
  IProductOfProvider,
  PRODUCTS_OF_PROVIDER_TTL_ES
} from '../../products-of-provider.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { ProductsOfProviderService } from '../../products-of-provider.service';

@Component({
  selector: 'pg-prd-of-prov',
  templateUrl: './products-of-provider.component.html'
})
export class ProductsOfProviderComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: ProductsOfProviderService) {
    super(PRODUCTS_OF_PROVIDER_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: PRODUCTS_OF_PROVIDER_TTL_ES,
      columns: [
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        { header: 'Código de producto del proveedor', field: 'code' },
        { header: 'Nombre del producto', field: 'nameProduct' },
        { header: 'Código del producto', field: 'codeProduct' },
        { header: 'Código de barras', field: 'barCodeProduct' }
      ]
      //
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductOfProvider[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
